<div class="radio-button-group">
  <label class="radio-button">
    <input type="radio"
           [value]="ASAP"
           [name]="'sendMessage'"
           [(ngModel)]="sendingOption"
           (ngModelChange)="onDataChanged.emit(ASAP)"/>
    <div class="font-md fw-bold"
         [translate]="'orderProcess.giftDelivery.sendItNow'">
      Send it now
    </div>
  </label>

  <label class="radio-button mt-2">
    <input type="radio"
           [value]="null"
           [name]="'sendMessage'"
           [(ngModel)]="sendingOption"
           (ngModelChange)="onDataChanged.emit(null)"/>
    <div class="font-md fw-bold"
         [translate]="'orderProcess.giftDelivery.sendItLater'">
      Send it at a later time
    </div>
  </label>
</div>
